import {useEffect} from 'react'

export function useDocumentSearchHandler(enabled: boolean, callback: () => unknown) {
  useEffect(() => {
    if (enabled) {
      const onKeyDown = (event: KeyboardEvent) => {
        if (
          (navigator.platform === 'MacIntel' ? event.metaKey : event.ctrlKey) &&
          (event.code === 'KeyF' || event.key === 'f')
        ) {
          event.preventDefault()
          callback()
        }
      }

      document.addEventListener('keydown', onKeyDown)
      return () => document.removeEventListener('keydown', onKeyDown)
    }

    return undefined
  }, [enabled, callback])
}
export function useDocumentSearchOccurancesHandlers(
  enabled: boolean,
  searchPreviousOccurance: () => unknown,
  searchNextOccurance: () => unknown,
) {
  useEffect(() => {
    if (enabled) {
      const onKeyDown = (event: KeyboardEvent) => {
        if (
          ((navigator.platform === 'MacIntel' ? event.metaKey : event.ctrlKey) &&
            (event.code === 'KeyG' || event.key === 'g')) ||
          (event.key === 'F3' && !event.ctrlKey && !event.altKey && !event.metaKey)
        ) {
          event.preventDefault()

          if (event.shiftKey) {
            searchPreviousOccurance()
          } else {
            searchNextOccurance()
          }
        }
      }

      document.addEventListener('keydown', onKeyDown)
      return () => document.removeEventListener('keydown', onKeyDown)
    }

    return undefined
  }, [enabled, searchPreviousOccurance, searchNextOccurance])
}
